<template>
    <div class="row">
        <div
            v-for="connection in appStore.getActiveConnections"
            :key="connection.id"
            class="col"
        >
            <i
                v-if="connection.status === 'connected'"
                class="fa-solid fa-link fa-lg text-success"
                :title="'Verbonden met ' + connection.config.label"
            ></i>
            <i
                v-if="connection.status === 'connecting'"
                class="fa-solid fa-link-slash fa-lg text-warning"
                :title="'Verbinding maken met ' + connection.config.label + '...'"
            ></i>
            <i
                v-if="connection.status === 'failed' || connection.status === 'disconnected'"
                class="fa-solid fa-link-slash fa-lg text-danger"
                :title="'Verbinding met ' + connection.config.label + ' verbroken'"
            ></i>
            <i
                v-if="connection.status === 'unavailable'"
                class="fa-solid fa-link-slash fa-lg text-danger"
                :title="'Server ' + connection.config.label + ' onbereikbaar'"
            ></i>
        </div>
    </div>
</template>

<script>
import { useAppStore } from "@stores/appStore";

export default {
    setup() {
        const appStore = useAppStore();
        return { appStore };
    },
};
</script>
